export default __webpack_public_path__ + "static/media/watch.5a96c0f4.svg";